/* eslint-disable */
import React from "react";

// ChunkLoadError recovery — see CLAUDE.md and audit report 2026-04-25 finding #1
const RELOAD_KEY = "clb_reload_attempted";
const RELOAD_WINDOW_MS = 30000;

function isChunkLoadError(error) {
  if (!error) return false;
  if (error.name === "ChunkLoadError") return true;
  const msg = String(error.message || "");
  return msg.includes("Loading chunk") || msg.includes("ChunkLoadError");
}

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, isChunkError: false };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error, isChunkError: isChunkLoadError(error) };
  }
  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
    if (!isChunkLoadError(error)) return;
    let recentlyAttempted = false;
    try {
      const prev = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
      const now = Date.now();
      if (prev && (now - prev) < RELOAD_WINDOW_MS) {
        recentlyAttempted = true;
      } else {
        sessionStorage.setItem(RELOAD_KEY, String(now));
      }
    } catch (e) { /* sessionStorage may be unavailable */ }
    if (recentlyAttempted) {
      // Already tried within 30s — don't loop. Fall through to TRY AGAIN UI.
      this.setState({ isChunkError: false });
      return;
    }
    setTimeout(() => { window.location.reload(); }, 1000);
  }
  render() {
    if (this.state.hasError) {
      if (this.state.isChunkError) {
        return (
          <div style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            height: '100%', minHeight: 300, padding: 40, textAlign: 'center',
          }}>
            <div style={{ fontSize: 'var(--text-xs)', letterSpacing: 'var(--tracking-wider)', textTransform: 'uppercase', color: 'var(--text-muted)', marginBottom: 'var(--space-md)', fontFamily: "'Montserrat', sans-serif" }}>
              Updating
            </div>
            <div style={{ fontSize: 'var(--text-sm)', color: 'var(--text)', fontFamily: "'Montserrat', sans-serif" }}>
              A new version is available — refreshing...
            </div>
          </div>
        );
      }
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          height: '100%', minHeight: 300, padding: 40, textAlign: 'center',
        }}>
          <div style={{ fontSize: 'var(--text-xs)', letterSpacing: 'var(--tracking-wider)', textTransform: 'uppercase', color: 'var(--text-muted)', marginBottom: 'var(--space-md)'}}>
            Something went wrong
          </div>
          <div style={{ fontSize: 'var(--text-sm)', color: 'var(--text)', marginBottom: 'var(--space-xl)', fontFamily: "'Montserrat', sans-serif" }}>
            This section encountered an error
          </div>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{
              padding: 'var(--space-sm) var(--space-xl)', border:'var(--border-thin) solid var(--gold)', borderRadius:'var(--radius-md)',
              background: 'none', color: 'var(--gold)', fontSize: 'var(--text-xs)', letterSpacing: 'var(--tracking-wider)',
              textTransform: 'uppercase', cursor: 'pointer', fontFamily: "'Montserrat', sans-serif",
            }}
          >
            Try Again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
